import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/figureofeight.png';
const _hoisted_1 = { class: "shop-voucher-page" };
const _hoisted_2 = {
    key: 0,
    class: "cart-basket-section mb-4"
};
const _hoisted_3 = {
    key: 0,
    class: "head"
};
const _hoisted_4 = { key: 3 };
const _hoisted_5 = {
    key: 1,
    class: "container categories-scroll"
};
const _hoisted_6 = {
    key: 2,
    class: "container"
};
const _hoisted_7 = {
    key: 7,
    class: "container"
};
const _hoisted_8 = {
    key: 8,
    class: "container"
};
const _hoisted_9 = {
    key: 10,
    class: "container"
};
const _hoisted_10 = {
    key: 11,
    class: "container"
};
const _hoisted_11 = { key: 4 };
const _hoisted_12 = {
    key: 0,
    class: "container relink-panel"
};
const _hoisted_13 = { key: 1 };
const _hoisted_14 = {
    key: 0,
    class: "container"
};
const _hoisted_15 = {
    key: 1,
    class: "container"
};
const _hoisted_16 = { key: 2 };
const _hoisted_17 = {
    key: 0,
    class: "noDiscounts"
};
const _hoisted_18 = {
    key: 0,
    class: "container"
};
const _hoisted_19 = {
    class: /*@__PURE__*/ _normalizeClass('smoothScrollContainerItem')
};
const _hoisted_20 = {
    class: /*@__PURE__*/ _normalizeClass('smoothScrollContainerItem')
};
const _hoisted_21 = {
    class: /*@__PURE__*/ _normalizeClass('smoothScrollContainerItem')
};
const _hoisted_22 = {
    class: /*@__PURE__*/ _normalizeClass('smoothScrollContainerItem')
};
const _hoisted_23 = {
    key: 1,
    class: "container"
};
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { class: "recommendedCarousel" };
const _hoisted_26 = {
    key: 1,
    class: "mb-8"
};
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import CategoryButton from './elements/CategoryButton.vue';
import SectionHeader from './elements/SectionHeader.vue';
import SmoothScrollContainer from './elements/SmoothScrollContainer.vue';
import MGNavPanel from './elements/MGNavPanel.vue';
import BuyWithConfidenceShoutPanel from './elements/BuyWithConfidenceShoutPanel.vue';
import HowItWorksVoucherPanel from './elements/HowItWorksVoucherShoutPanel.vue';
import VoucherRecommendedForYou from './elements/VoucherRecommendedForYou.vue';
import VoucherMerchantCard from './elements/VoucherMerchantCard.vue';
import SwipeCarousel from './elements/SwipeCarousel.vue';
import VoucherSavingSuggestions from './elements/VoucherSavingSuggestions.vue';
import ReLinkAccountsForVouchersShoutPanel from './elements/ReLinkAccountsForVouchersShoutPanel.vue';
import VoucherBasket from './elements/VoucherBasket.vue';
import SpendingPotButton from './elements/SpendingPotButton.vue';
import MGTextField from './elements/MGTextField.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShopVouchersPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankingInfo } = useBanking();
        const vouchers = useVouchers();
        const query = ref(null);
        const filter = ref(route.query.filters ?? null);
        const filterCount = ref(0);
        const title = ref(route.query.title ?? 'Shop Vouchers');
        const image = ref(route.query.image ?? null);
        const favouriteVouchers = ref(null);
        const topSavingsVouchersThisMonth = ref(null);
        const biggestDiscounts6Months = ref(null);
        const biggestSavings3Months = ref(null);
        const featuredVouchers = ref(null);
        const boostedVouchers = ref(null);
        const forYou = ref(false);
        const recommendedVouchers6Months = ref(null);
        const recommendedVouchers3Months = ref(null);
        const recommendedVouchers1Month = ref(null);
        const recommendedVouchersLastMonth = ref(null);
        const topMerchantSpend = ref(null);
        const topMerchantSaving = ref(null);
        const topMerchantDiscount = ref(null);
        const topMerchantUsed = ref(null);
        const activeCategories = ref(null);
        const cartItems = ref([]);
        const discountsStatement = ref(null);
        const periodString = ref('');
        const cartIcon = computed(() => {
            if (cartItems.value.length == 1) {
                console.log('Cart icon URL:', cartItems.value[0]);
                return cartItems.value[0].availableVoucher.cardUrl;
            }
            else {
                return '@/assets/basket.svg';
            }
        });
        const cartVoucherCount = computed(() => {
            return cartItems.value ? cartItems.value.length : 0;
        });
        const cartTotalAmount = computed(() => {
            if (!cartItems.value || cartItems.value.length === 0)
                return 0;
            return cartItems.value.reduce((total, item) => {
                return total + (parseFloat(item.amount) || 0);
            }, 0);
        });
        const savedToSpendBalance = computed(() => {
            return discountsStatement.value?.savedToSpendBalance || 0;
        });
        async function onLoad() {
            if (route.query.recommended !== undefined) {
                forYou.value = route.query.recommended === 'true';
            }
            vouchers.getCart((r) => {
                console.log('Cart items retrieved:', r);
                if (r && r.length > 0) {
                    cartItems.value = r;
                }
            });
            vouchers.getCategories(() => {
                activeCategories.value = state.categories.filter((c) => c.active);
            });
            getCustomer(() => {
                vouchers.getCustomerVouchersSummary();
                getBankingInfo();
                vouchers.getDiscountsStatement((result) => {
                    discountsStatement.value = result;
                });
            });
            vouchers.getAvailableVouchers(() => {
                favouriteVouchers.value = state.availableVouchers.filter((v) => v.favourite);
                featuredVouchers.value = state.availableVouchers.filter((v) => v.featured);
                boostedVouchers.value = state.availableVouchers.filter((v) => v.manualOverride);
                state.availableVouchers.forEach((v) => {
                    vouchers.removeUnavailableDiscountProviders(v);
                });
                topSavingsVouchersThisMonth.value = topSavings(state.availableVouchers);
            });
            vouchers.getRecommendedVouchers(-180, (r) => {
                recommendedVouchers6Months.value = JSON.parse(JSON.stringify(r));
                biggestDiscounts6Months.value = topDiscounts(recommendedVouchers6Months.value);
                recommendedVouchersLastMonth.value = recommendedVouchers6Months.value.filter((v) => {
                    return v.lastMonthSpend && Math.abs(v.lastMonthSpend) > 0;
                }).slice(0, 3);
                const lastMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
                periodString.value = lastMonth.toLocaleString('default', { month: 'long' });
                topMerchantSpend.value = [...recommendedVouchers6Months.value].sort((a, b) => (Math.abs(b.spent || 0) - Math.abs(a.spent || 0))).slice(0, 1);
                topMerchantSaving.value = [...recommendedVouchers6Months.value].sort((a, b) => (Math.abs(b.biggestSaving || 0) - Math.abs(a.biggestSaving || 0))).slice(0, 1);
                topMerchantDiscount.value = [...recommendedVouchers6Months.value].sort((a, b) => (b.effectiveDiscountPercentage || 0) - (a.effectiveDiscountPercentage || 0)).slice(0, 1);
                topMerchantUsed.value = [...recommendedVouchers6Months.value].sort((a, b) => (b.transactionCount || 0) - (a.transactionCount || 0)).slice(0, 1);
            });
            vouchers.getRecommendedVouchers(-90, (r) => {
                recommendedVouchers3Months.value = JSON.parse(JSON.stringify(r));
                biggestSavings3Months.value = topSavings(recommendedVouchers3Months.value);
            });
            vouchers.getRecommendedVouchers(-30, (r) => {
                recommendedVouchers1Month.value = JSON.parse(JSON.stringify(r));
            });
            vouchers.getCustomerVouchers();
        }
        function topSavings(voucherList) {
            var top = voucherList.sort((a, b) => {
                return (b.effectiveDiscountPercentage || 0) - (a.effectiveDiscountPercentage || 0);
            });
            return top.slice(0, 10);
        }
        function topDiscounts(voucherList) {
            var top = voucherList.sort((a, b) => {
                return (b.saving || 0) - (a.saving || 0);
            });
            console.log('top discounts', top);
            return top.slice(0, 10);
        }
        function onTopSavingsSectionHeaderAction() {
            router.push({ path: '/TopSavingsVouchers' });
        }
        function onCategorySectionHeaderAction() {
            router.push({ path: '/VoucherCategories' });
        }
        function onWhereYouCouldHaveSavedSectionHeaderAction() {
            alert('Where you could have saved section header action clicked!');
        }
        function onFeaturedSectionHeaderAction() {
            router.push({ path: '/FeaturedVouchers' });
        }
        function onRecommendedSectionHeaderAction() {
            router.push({ path: '/RecommendedVouchers' });
        }
        function onBiggestDiscountsSectionHeaderAction() {
            if (biggestDiscounts6Months.value && biggestDiscounts6Months.value.length > 0) {
                router.push({ path: '/BiggestDiscountsVouchers' });
            }
        }
        function onBoostedClick() {
            router.push({ path: '/BoostedVouchers' });
        }
        function categoryClicked(o) {
            router.push({ path: '/vouchers', query: o });
        }
        function voucherClicked(voucher) {
            router.push({ path: '/vouchers/amount/' + voucher.id });
        }
        function onTopMerchantSpendClick() {
            if (!isNaN(topMerchantSpend.value?.[0]?.spent) && Math.abs(topMerchantSpend.value?.[0]?.spent) > 0) {
                voucherClicked(topMerchantSpend.value[0]);
            }
            else {
                router.push({ path: '/wallet' });
            }
        }
        function onTopMerchantSavingClick() {
            if (!isNaN(topMerchantSaving.value?.[0]?.spent) && Math.abs(topMerchantSaving.value?.[0]?.spent) > 0) {
                voucherClicked(topMerchantSaving.value[0]);
            }
            else {
                router.push({ path: '/wallet' });
            }
        }
        function onTopMerchantDiscountClick() {
            if (!isNaN(topMerchantDiscount.value?.[0]?.spent) && Math.abs(topMerchantDiscount.value?.[0]?.spent) > 0) {
                voucherClicked(topMerchantDiscount.value[0]);
            }
            else {
                router.push({ path: '/wallet' });
            }
        }
        function onTopMerchantUsedClick() {
            if (!isNaN(topMerchantUsed.value?.[0]?.spent) && Math.abs(topMerchantUsed.value?.[0]?.spent) > 0) {
                voucherClicked(topMerchantUsed.value[0]);
            }
            else {
                router.push({ path: '/wallet' });
            }
        }
        function calculateSavingAmount(voucher) {
            if (voucher.lastMonthSpend && voucher.effectiveDiscountPercentage) {
                return (Math.abs(voucher.lastMonthSpend) * (voucher.effectiveDiscountPercentage / 100));
            }
            return 0;
        }
        function calculateSpendAmount(voucher) {
            return isNaN(voucher.lastMonthSpend) ? state.formatter.format(0) : state.formatter.format(Math.abs(voucher.lastMonthSpend));
        }
        function calculateSpendLabel() {
            const lastMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
            const monthString = lastMonth.toLocaleString('default', { month: 'long' });
            return `${monthString} spend`;
        }
        function tabClicked(isForYou) {
            forYou.value = isForYou;
        }
        function gotoSearch() {
            router.push({ path: '/vouchers/search' });
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                vouchers.removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                vouchers.addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        function handleCartBasketClick() {
            console.log('Cart basket clicked, navigating to cart...');
            router.push('/VoucherCart');
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_carousel_item = _resolveComponent("v-carousel-item");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: title.value,
                    border: image.value ? 0 : null,
                    bgcolor: image.value ? '#281C3Bff' : 'white',
                    darkBgcolor: 'var(--background-color-main)',
                    color: image.value ? 'white' : null
                }, null, 8, ["title", "border", "bgcolor", "color"]),
                _createElementVNode("div", _hoisted_1, [
                    (cartVoucherCount.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(VoucherBasket, {
                                voucherCount: cartVoucherCount.value,
                                totalAmount: cartTotalAmount.value,
                                basketText: cartVoucherCount.value > 1 ? 'Shopping Basket' : 'Pick up where you left off',
                                colour: "#C6CAE5",
                                icon: cartIcon.value,
                                onClick: handleCartBasketClick
                            }, null, 8, ["voucherCount", "totalAmount", "basketText", "icon"])
                        ]))
                        : _createCommentVNode("", true),
                    _createVNode(_Transition, null, {
                        default: _withCtx(() => [
                            (filter.value && _unref(state).availableVouchers)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("div", {
                                        class: "header",
                                        style: _normalizeStyle('background-image: url(' + image.value + ')')
                                    }, [
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "v-col-7 title-col" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("h1", null, _toDisplayString(title.value), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_col, { class: "v-col-5 chip-col" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_chip, {
                                                            color: "white",
                                                            variant: "flat"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(filterCount.value) + " card(s)", 1)
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ], 4)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    (savedToSpendBalance.value > 0 && !filter.value)
                        ? (_openBlock(), _createBlock(SpendingPotButton, {
                            key: 1,
                            amount: savedToSpendBalance.value,
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/SavedToSpend'))),
                            class: "spending-pot-button-row"
                        }, null, 8, ["amount"]))
                        : _createCommentVNode("", true),
                    (!filter.value)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 2,
                            class: "search-row"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "search-col" }, {
                                    default: _withCtx(() => [
                                        _createVNode(MGTextField, {
                                            ref: "search",
                                            modelValue: query.value,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((query).value = $event)),
                                            "prepend-inner-icon": "mdi-magnify",
                                            density: "compact",
                                            label: "Search all vouchers",
                                            variant: "solo",
                                            flat: true,
                                            "hide-details": "",
                                            clearable: "",
                                            "single-line": "",
                                            "bg-color": "#eeeeee",
                                            onClick: gotoSearch
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createVNode(_component_v_row, { class: "topMenuRow" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "topMenuCol" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        class: _normalizeClass(['topTabButton', { selected: !forYou.value }]),
                                        title: "",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (tabClicked(false)))
                                    }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                            _createTextVNode("Featured")
                                        ])),
                                        _: 1
                                    }, 8, ["class"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { class: "topMenuCol" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                        class: _normalizeClass(['topTabButton', { selected: forYou.value }]),
                                        title: "",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (tabClicked(true)))
                                    }, {
                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                            _createTextVNode("For you")
                                        ])),
                                        _: 1
                                    }, 8, ["class"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (!forYou.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (activeCategories.value && activeCategories.value.length > 0)
                                ? (_openBlock(), _createBlock(SectionHeader, {
                                    key: 0,
                                    class: "mt-1",
                                    title: "Categories",
                                    subtitle: "Discover how you can save",
                                    actionLabel: "View all",
                                    onAction: onCategorySectionHeaderAction
                                }))
                                : _createCommentVNode("", true),
                            (activeCategories.value && activeCategories.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(SmoothScrollContainer, null, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeCategories.value, (category, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass('smoothScrollContainerItem'),
                                                    key: category.id
                                                }, [
                                                    (_openBlock(), _createBlock(CategoryButton, {
                                                        key: index,
                                                        title: category.buttonTitle,
                                                        image: category.buttonImage,
                                                        onClick: ($event) => { categoryClicked({ title: category.pageTitle, filters: category.providerFilters, image: category.pageImage }); }
                                                    }, null, 8, ["title", "image", "onClick"]))
                                                ]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(SmoothScrollContainer, null, {
                                        default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                return _createElementVNode("div", {
                                                    class: _normalizeClass('smoothScrollContainerItem'),
                                                    key: i
                                                }, [
                                                    _createVNode(_component_v_skeleton_loader, {
                                                        type: "image, article",
                                                        height: "220",
                                                        class: "mr-2"
                                                    })
                                                ]);
                                            }), 64))
                                        ]),
                                        _: 1
                                    })
                                ])),
                            (!boostedVouchers.value)
                                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                                    key: 3,
                                    type: "list-item-two-line",
                                    height: "80",
                                    class: "mb-6"
                                }))
                                : (boostedVouchers.value && boostedVouchers.value.length > 0)
                                    ? (_openBlock(), _createBlock(MGNavPanel, {
                                        key: 4,
                                        title: "Boosted",
                                        subtitle: "Save whilst they last",
                                        icon: require('@/assets/lightning-bolt.png'),
                                        background: require('@/assets/bg/boosted.png'),
                                        onClick: onBoostedClick,
                                        class: "mb-6"
                                    }, null, 8, ["icon", "background"]))
                                    : _createCommentVNode("", true),
                            (_unref(state).vouchersSummary && (_unref(state).vouchersSummary.allTimeSavings ?? 0) == 0)
                                ? (_openBlock(), _createBlock(SwipeCarousel, {
                                    key: 5,
                                    showArrows: false,
                                    showButtons: false,
                                    paginationDots: true,
                                    itemCount: 2,
                                    height: '300px',
                                    class: "howItWorksCarousel"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_carousel_item, null, {
                                            default: _withCtx(() => [
                                                _createVNode(BuyWithConfidenceShoutPanel, {
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (_unref(router).push('/BuyWithConfidence')))
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_carousel_item, null, {
                                            default: _withCtx(() => [
                                                _createVNode(HowItWorksVoucherPanel, {
                                                    onClick: _cache[5] || (_cache[5] = ($event) => (_unref(router).push('/HowItWorksVouchers')))
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            (topSavingsVouchersThisMonth.value && topSavingsVouchersThisMonth.value.length > 0)
                                ? (_openBlock(), _createBlock(SectionHeader, {
                                    key: 6,
                                    class: "sectionHeader",
                                    title: "Top Savings",
                                    subtitle: "Explore the best deals this month",
                                    actionLabel: "View all",
                                    onAction: onTopSavingsSectionHeaderAction
                                }))
                                : _createCommentVNode("", true),
                            (topSavingsVouchersThisMonth.value && topSavingsVouchersThisMonth.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(SmoothScrollContainer, null, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topSavingsVouchersThisMonth.value, (v, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass('smoothScrollContainerItem'),
                                                    key: v.id
                                                }, [
                                                    (_openBlock(), _createBlock(VoucherRecommendedForYou, {
                                                        key: index,
                                                        imageUrl: v.merchant.category?.buttonImage,
                                                        isFavorited: v.favourite,
                                                        merchantLogoUrl: v.cardUrl,
                                                        merchantName: v.merchant.name,
                                                        savingsPercentage: v.effectiveDiscountPercentage,
                                                        small: true,
                                                        onFavoriteClicked: () => { favouriteToggled(v); },
                                                        onClick: ($event) => (voucherClicked(v)),
                                                        formatter: _unref(state).formatter
                                                    }, null, 8, ["imageUrl", "isFavorited", "merchantLogoUrl", "merchantName", "savingsPercentage", "onFavoriteClicked", "onClick", "formatter"]))
                                                ]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createVNode(SmoothScrollContainer, null, {
                                        default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                return _createElementVNode("div", {
                                                    class: _normalizeClass('smoothScrollContainerItem'),
                                                    key: i
                                                }, [
                                                    _createVNode(_component_v_skeleton_loader, {
                                                        type: "image, article",
                                                        height: "220",
                                                        class: "mr-2"
                                                    })
                                                ]);
                                            }), 64))
                                        ]),
                                        _: 1
                                    })
                                ])),
                            (featuredVouchers.value && featuredVouchers.value.length > 0)
                                ? (_openBlock(), _createBlock(SectionHeader, {
                                    key: 9,
                                    title: "Featured Discounts",
                                    subtitle: "Explore our featured discounts",
                                    actionLabel: "View all",
                                    onAction: onFeaturedSectionHeaderAction,
                                    class: "sectionHeader"
                                }))
                                : _createCommentVNode("", true),
                            (featuredVouchers.value && featuredVouchers.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createVNode(SmoothScrollContainer, null, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featuredVouchers.value, (card, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass('smoothScrollContainerItem'),
                                                    key: index
                                                }, [
                                                    _createVNode(VoucherMerchantCard, {
                                                        logoUrl: card.cardUrl,
                                                        merchantName: card.merchant.name,
                                                        savingPercentage: card.effectiveDiscountPercentage,
                                                        onFavoriteToggled: () => { favouriteToggled(card); },
                                                        onClick: ($event) => (voucherClicked(card)),
                                                        isFavorited: card.favourite
                                                    }, null, 8, ["logoUrl", "merchantName", "savingPercentage", "onFavoriteToggled", "onClick", "isFavorited"])
                                                ]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(SmoothScrollContainer, null, {
                                        default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                return _createElementVNode("div", {
                                                    class: _normalizeClass('smoothScrollContainerItem'),
                                                    key: i
                                                }, [
                                                    _createVNode(_component_v_skeleton_loader, {
                                                        type: "image, article",
                                                        height: "220",
                                                        class: "mr-2"
                                                    })
                                                ]);
                                            }), 64))
                                        ]),
                                        _: 1
                                    })
                                ])),
                            (_unref(state).vouchersSummary && (_unref(state).vouchersSummary.allTimeSavings ?? 0) > 0)
                                ? (_openBlock(), _createBlock(SwipeCarousel, {
                                    key: 12,
                                    showArrows: false,
                                    showButtons: false,
                                    paginationDots: true,
                                    itemCount: 2,
                                    height: '300px',
                                    class: "howItWorksCarousel"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_carousel_item, null, {
                                            default: _withCtx(() => [
                                                _createVNode(BuyWithConfidenceShoutPanel, {
                                                    onClick: _cache[6] || (_cache[6] = ($event) => (_unref(router).push('/BuyWithConfidence')))
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_carousel_item, null, {
                                            default: _withCtx(() => [
                                                _createVNode(HowItWorksVoucherPanel, {
                                                    onClick: _cache[7] || (_cache[7] = ($event) => (_unref(router).push('/HowItWorksVouchers')))
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_unref(state).bankInfo && _unref(state).bankInfo.accounts.length == 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(ReLinkAccountsForVouchersShoutPanel)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", null, [
                                        _createVNode(SectionHeader, {
                                            title: "Biggest Discounts",
                                            subtitle: "Based on your spending in the last 6 months",
                                            actionLabel: biggestDiscounts6Months.value && biggestDiscounts6Months.value.length > 0 ? 'View all' : null,
                                            onAction: onBiggestDiscountsSectionHeaderAction,
                                            class: "mt-1"
                                        }, null, 8, ["actionLabel"]),
                                        (biggestDiscounts6Months.value && biggestDiscounts6Months.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _createVNode(SmoothScrollContainer, null, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(biggestDiscounts6Months.value, (v, index) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                class: _normalizeClass('smoothScrollContainerItem'),
                                                                key: v.id
                                                            }, [
                                                                (_openBlock(), _createBlock(VoucherRecommendedForYou, {
                                                                    key: index,
                                                                    imageUrl: v.discountCategory.buttonImage,
                                                                    isFavorited: v.favourite,
                                                                    merchantLogoUrl: v.cardUrl,
                                                                    merchantName: v.merchant.name,
                                                                    savingsAmount: v.saving,
                                                                    savingsPercentage: v.effectiveDiscountPercentage,
                                                                    small: true,
                                                                    onFavoriteClicked: () => { favouriteToggled(v); },
                                                                    onClick: ($event) => (voucherClicked(v)),
                                                                    formatter: _unref(state).formatter
                                                                }, null, 8, ["imageUrl", "isFavorited", "merchantLogoUrl", "merchantName", "savingsAmount", "savingsPercentage", "onFavoriteClicked", "onClick", "formatter"]))
                                                            ]));
                                                        }), 128))
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : (biggestDiscounts6Months.value == null)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    _createVNode(SmoothScrollContainer, null, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                                return _createElementVNode("div", {
                                                                    class: _normalizeClass('smoothScrollContainerItem'),
                                                                    key: i
                                                                }, [
                                                                    _createVNode(_component_v_skeleton_loader, {
                                                                        type: "image, article",
                                                                        height: "220",
                                                                        class: "mr-2"
                                                                    })
                                                                ]);
                                                            }), 64))
                                                        ]),
                                                        _: 1
                                                    })
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                    (!filter.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[10] || (_cache[10] = [
                                                            _createElementVNode("img", {
                                                                class: "mt-4",
                                                                src: _imports_0
                                                            }, null, -1),
                                                            _createElementVNode("div", { class: "mt-4" }, [
                                                                _createElementVNode("p", null, [
                                                                    _createElementVNode("b", null, "We couldn't see enough recent activity to tailor offers to you.")
                                                                ]),
                                                                _createTextVNode(" Connect a regularly used account to unlock smarter suggestions. ")
                                                            ], -1)
                                                        ])))
                                                        : _createCommentVNode("", true)
                                                ]))
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createVNode(SectionHeader, {
                                            title: "Where you could have saved",
                                            subtitle: "Based on your spending in the last 6 months",
                                            onAction: onWhereYouCouldHaveSavedSectionHeaderAction,
                                            class: "sectionHeader"
                                        }),
                                        (recommendedVouchers6Months.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                _createVNode(SmoothScrollContainer, null, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_19, [
                                                            (_openBlock(), _createBlock(VoucherSavingSuggestions, {
                                                                key: 1,
                                                                labelValue: isNaN(topMerchantSpend.value[0]?.spent) ? _unref(state).formatter.format(0) : _unref(state).formatter.format(Math.abs(topMerchantSpend.value[0]?.spent)),
                                                                label: "Total spend",
                                                                logoUrl: topMerchantSpend.value[0]?.merchant.logoUrl,
                                                                savingAmount: isNaN(topMerchantSpend.value[0]?.saving) ? _unref(state).formatter.format(0) : _unref(state).formatter.format(topMerchantSpend.value[0]?.saving),
                                                                savingPercentage: isNaN(topMerchantSpend.value[0]?.effectiveDiscountPercentage) ? 0 : topMerchantSpend.value[0]?.effectiveDiscountPercentage,
                                                                onClick: onTopMerchantSpendClick
                                                            }, null, 8, ["labelValue", "logoUrl", "savingAmount", "savingPercentage"]))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_20, [
                                                            (_openBlock(), _createBlock(VoucherSavingSuggestions, {
                                                                key: 2,
                                                                label: "Biggest single saving",
                                                                logoUrl: topMerchantSaving.value[0]?.merchant.logoUrl,
                                                                savingAmount: isNaN(topMerchantSaving.value[0]?.saving) ? _unref(state).formatter.format(0) : _unref(state).formatter.format(topMerchantSaving.value[0]?.saving),
                                                                savingPercentage: isNaN(topMerchantSaving.value[0]?.effectiveDiscountPercentage) ? 0 : topMerchantSaving.value[0]?.effectiveDiscountPercentage,
                                                                onClick: onTopMerchantSavingClick
                                                            }, null, 8, ["logoUrl", "savingAmount", "savingPercentage"]))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_21, [
                                                            (_openBlock(), _createBlock(VoucherSavingSuggestions, {
                                                                key: 3,
                                                                label: "Biggest discount",
                                                                logoUrl: topMerchantDiscount.value[0]?.merchant.logoUrl,
                                                                savingAmount: isNaN(topMerchantDiscount.value[0]?.saving) ? _unref(state).formatter.format(0) : _unref(state).formatter.format(topMerchantDiscount.value[0]?.saving),
                                                                savingPercentage: isNaN(topMerchantDiscount.value[0]?.effectiveDiscountPercentage) ? 0 : topMerchantDiscount.value[0]?.effectiveDiscountPercentage,
                                                                onClick: onTopMerchantDiscountClick
                                                            }, null, 8, ["logoUrl", "savingAmount", "savingPercentage"]))
                                                        ]),
                                                        _createElementVNode("div", _hoisted_22, [
                                                            (_openBlock(), _createBlock(VoucherSavingSuggestions, {
                                                                key: 4,
                                                                label: "Most frequent",
                                                                labelValue: topMerchantUsed.value[0]?.transactionCount ?? 0,
                                                                logoUrl: topMerchantUsed.value[0]?.merchant.logoUrl,
                                                                savingAmount: isNaN(topMerchantUsed.value[0]?.saving) ? _unref(state).formatter.format(0) : _unref(state).formatter.format(topMerchantUsed.value[0]?.saving),
                                                                savingPercentage: isNaN(topMerchantUsed.value[0]?.effectiveDiscountPercentage) ? 0 : topMerchantUsed.value[0]?.effectiveDiscountPercentage,
                                                                onClick: onTopMerchantUsedClick
                                                            }, null, 8, ["labelValue", "logoUrl", "savingAmount", "savingPercentage"]))
                                                        ])
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _createVNode(SmoothScrollContainer, null, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                            return _createElementVNode("div", {
                                                                class: _normalizeClass('smoothScrollContainerItem'),
                                                                key: i
                                                            }, [
                                                                _createVNode(_component_v_skeleton_loader, {
                                                                    type: "image, article",
                                                                    height: "220",
                                                                    class: "mr-2"
                                                                })
                                                            ]);
                                                        }), 64))
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                    ]),
                                    (recommendedVouchersLastMonth.value && recommendedVouchersLastMonth.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _createVNode(SectionHeader, {
                                                title: "Your spending last month",
                                                subtitle: `Based on where you shopped in ${periodString.value}`,
                                                actionLabel: "View all",
                                                onAction: onRecommendedSectionHeaderAction,
                                                class: "sectionHeader"
                                            }, null, 8, ["subtitle"]),
                                            _createElementVNode("div", _hoisted_25, [
                                                _createVNode(SwipeCarousel, {
                                                    showArrows: false,
                                                    showButtons: false,
                                                    paginationDots: true,
                                                    itemCount: recommendedVouchersLastMonth.value?.length || 1,
                                                    height: '370px'
                                                }, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedVouchersLastMonth.value, (v, index) => {
                                                            return (_openBlock(), _createBlock(_component_v_carousel_item, {
                                                                key: v.id
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (_openBlock(), _createBlock(VoucherRecommendedForYou, {
                                                                        key: index,
                                                                        category: v.discountCategory.pageTitle,
                                                                        imageUrl: v.discountCategory.buttonImage,
                                                                        isFavorited: v.favourite,
                                                                        merchantLogoUrl: v.merchant.logoUrl,
                                                                        merchantName: v.merchant.name,
                                                                        savingsAmount: calculateSavingAmount(v),
                                                                        savingsPercentage: v.effectiveDiscountPercentage,
                                                                        cardLabel: "Where you spent the most",
                                                                        spendAmount: calculateSpendAmount(v),
                                                                        spendLabel: calculateSpendLabel(v),
                                                                        onFavoriteClicked: () => { favouriteToggled(v); },
                                                                        onClick: ($event) => (voucherClicked(v)),
                                                                        formatter: _unref(state).formatter
                                                                    }, null, 8, ["category", "imageUrl", "isFavorited", "merchantLogoUrl", "merchantName", "savingsAmount", "savingsPercentage", "spendAmount", "spendLabel", "onFavoriteClicked", "onClick", "formatter"]))
                                                                ]),
                                                                _: 2
                                                            }, 1024));
                                                        }), 128))
                                                    ]),
                                                    _: 1
                                                }, 8, ["itemCount"])
                                            ])
                                        ]))
                                        : (recommendedVouchersLastMonth.value == null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                _createVNode(SwipeCarousel, {
                                                    showArrows: false,
                                                    showButtons: false,
                                                    paginationDots: true,
                                                    height: '360px'
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("div", null, [
                                                            _createVNode(_component_v_skeleton_loader, {
                                                                type: "card",
                                                                height: "220",
                                                                class: "mr-2"
                                                            })
                                                        ])
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true)
                                ]))
                        ]))
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
